 

export default class VocationalTraning {

    Id: string | undefined;
    ExpertiseId: number | undefined;
    ExpertiseValue: string | undefined;
    DateAcquisition: Date | undefined;
    NumberRQE: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new VocationalTraning();
    }
}